import React from "react";
import closedImage from "../assets/images/banners/closed_icon.png"

const KitchenClosed = ({ openTime = "9:30 AM" }) => {

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <img
                    src={closedImage}
                    style={{height:150,width:150}} />

                <h1 style={styles.title}>Sorry, the kitchen is currently closed.</h1>

                <p style={styles.text}>
                    It will open at <strong>{openTime}</strong>
                </p>
            </div>
        </div>
    );
};

export default KitchenClosed;

const styles = {
    container: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5",
    },
    card: {
        padding: "40px",
        borderRadius: "12px",
        background: "#fff",
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
        textAlign: "center",
    },
    icon: {
        fontSize: "50px",
        marginBottom: "15px",
    },
    title: {
        fontSize: "26px",
        marginBottom: "10px",
    },
    text: {
        fontSize: "16px",
        color: "#555",
    },
};